import React, {
  ComponentPropsWithRef,
  ReactElement,
  useCallback,
  useEffect,
  useState,
} from 'react';
import { EmblaCarouselType } from 'embla-carousel';

import s from './Embla.module.scss';
import getAssetLink from '../../../../util/getAssetLink';

type UsePrevNextButtonsType = {
  prevBtnDisabled: boolean;
  nextBtnDisabled: boolean;
  onPrevButtonClick: () => void;
  onNextButtonClick: () => void;
};

export const usePrevNextButtons = (
  emblaApi: EmblaCarouselType | undefined,
): UsePrevNextButtonsType => {
  const [prevBtnDisabled, setPrevBtnDisabled] = useState(true);
  const [nextBtnDisabled, setNextBtnDisabled] = useState(true);

  const onPrevButtonClick = useCallback(() => {
    if (!emblaApi) return;
    emblaApi.scrollPrev();
  }, [emblaApi]);

  const onNextButtonClick = useCallback(() => {
    if (!emblaApi) return;
    emblaApi.scrollNext();
  }, [emblaApi]);

  const onSelect = useCallback((emblaApi_: EmblaCarouselType) => {
    setPrevBtnDisabled(!emblaApi_.canScrollPrev());
    setNextBtnDisabled(!emblaApi_.canScrollNext());
  }, []);

  useEffect(() => {
    if (!emblaApi) return;

    onSelect(emblaApi);
    emblaApi.on('reInit', onSelect).on('select', onSelect);
  }, [emblaApi, onSelect]);

  return {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  };
};

type PropType = ComponentPropsWithRef<'button'>;

export function PrevButton(props: PropType): ReactElement {
  const { children, ...restProps } = props;

  return (
    <button
      className={s.prevButton}
      type="button"
      aria-label="zurück"
      {...restProps}
    >
      <img src={getAssetLink('startpage/caret_left.png')} alt="zurück" />
    </button>
  );
}

export function NextButton(props: PropType): ReactElement {
  const { children, ...restProps } = props;

  return (
    <button
      className={s.nextButton}
      type="button"
      aria-label="weiter"
      {...restProps}
    >
      <img src={getAssetLink('startpage/caret_right.png')} alt="weiter" />
    </button>
  );
}
